module.exports = __webpack_public_path__ + "static/media/backWave18.d311354a.svg";